import { apiClient } from './client';

export const jasperApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        // Turn `getJasper` into a mutation using the GET method
        getJasper: builder.mutation<
            any,
            { product_type: string; book_id: any; school_id: any }
        >({
            query: ({ product_type, book_id, school_id }) => ({
                url: `api/jasper?product_type=${product_type}&book_id=${book_id}&school_id=${school_id}`,
                method: 'GET',
            }),
        }),
    }),
});

export const { useGetJasperMutation } = jasperApi;
export default jasperApi;
